import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { ANALYTICS } from '../../analytics/constants';
import { PayloadProps, track } from '../../analytics/index';
import { Modal } from '../../components/modal';
import { ViewWrapper } from '../../components/view-wrapper';
import { CONSTANTS } from '../../config/constants';
import { useMerchant } from '../../hooks/useMerchant';
import { Filters } from '../../models/table';
import { CommerceServices } from '../../services/commerce';
import { defaultFilters, defaultPagination } from '../../utils/defaults';
import { ModalMerchantCreate } from './create-merchant-modal';
import { ButtonHead, ContainerButton, HeadContainer, TitlePage } from './style';
import { CommerceTable } from './table';

const customDefaultFilters: Filters = {
	...defaultFilters,
	typeSelected: '',
	stateSelected: '',
};
interface ModalProps {
	title: string;
	loader: boolean;
	show: boolean;
	url: string;
	typeModal: string;
}

const defaultModal: ModalProps = {
	title: '',
	loader: false,
	show: false,
	url: '',
	typeModal: 'default',
};

const Commerce = () => {
	const { merchantSelected } = useMerchant();
	const [filters, setFilters] = useState(customDefaultFilters);
	const [pagination, setPagination] = useState(defaultPagination);
	const [total, setTotal] = useState(0);
	const [modal, setModal] = useState<ModalProps>(defaultModal);
	const [onRefeth, setOnRefeth] = useState<boolean>(false);
	const {
		data: table,
		isFetching,
		isFetched,
		isLoading,
		refetch,
	} = useQuery({
		enabled: !!merchantSelected,
		useErrorBoundary: true,
		keepPreviousData: true,
		queryKey: [
			CONSTANTS.services.development.commerceInformation,
			merchantSelected?.code,
			pagination,
			filters,
		],
		queryFn: () =>
			CommerceServices.getTableData({
				merchantCode: merchantSelected?.code as string,
				pagination,
				filters: {
					...filters,
					typeSelected: filters.typeSelected,
				},
			}),
		onSuccess: (data) => {
			if (data) setTotal(data.total);
		},
	});

	useEffect(() => {
		setFilters(customDefaultFilters);
		setPagination(defaultPagination);
	}, [merchantSelected]);

	useEffect(() => {
		const trackInfo: PayloadProps = {
			type: 'screen',
			pageView: ANALYTICS.commerce.page_view,
			source: 'GTM',
		};
		track(trackInfo);
	}, []);

	const handleCloseModal = () => {
		setModal(defaultModal);
		if (onRefeth) {
			refetch();
			setOnRefeth(false);
		}
	};

	return (
		<ViewWrapper title="Comercios" isLoading={isFetching || isLoading}>
			<>
				<HeadContainer>
					<TitlePage>Comercios</TitlePage>

					<ContainerButton>
						<ButtonHead
							variant="abell"
							onClick={() =>
								setModal({
									...modal,
									title: 'Crear comercio',
									show: true,
									typeModal: 'createMerchant',
								})
							}
						>
							Crear comercio
						</ButtonHead>
					</ContainerButton>
				</HeadContainer>
				{modal.show && (
					<Modal
						type="medium"
						title={modal.title}
						show={modal.show}
						onClose={handleCloseModal}
						allowCloseModal={!modal.loader}
					>
						<>
							{modal.typeModal == 'createMerchant' && (
								<ModalMerchantCreate
									setShowFinalizedModal={handleCloseModal}
									onRefeth={() => setOnRefeth(true)}
								/>
							)}
						</>
					</Modal>
				)}
				<CommerceTable
					data={table?.tableInfo || []}
					isLoading={isFetching && !isFetched}
					stateList={table?.typeOfStatus || []}
					filters={filters}
					onFilterChange={setFilters}
					pagination={pagination}
					setPagination={setPagination}
					totalResults={total}
					refetch={refetch}
				/>
			</>
		</ViewWrapper>
	);
};

export { Commerce };
